module.exports = __webpack_public_path__ + "static/media/menuInsightIcon.25e60929.svg";